import React, { Fragment, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import History from '../../components/history';
import Container from '../../components/container';
import useReloadDummy from '../../../scripts/hooks/use.reload.dummy';
import useGlobal from '../../../store';
import PopupSettings from '../../popups/popup.settings';
import PopupDealInfo from '../../popups/popup.deal.info';
import WebSockets from '../../components/websockets';
import './scalculator.scss';
import Orders from '../../components/orders';

const Scalculator = () => {

  const [ globalState, globalActions ] = useGlobal();

  const { 

    currency,
    token_tinkoff_extension

  } = globalState;

  const { deals, changeStates } = globalActions;
  const popupSettings = PopupSettings();
  const popupDealInfo = PopupDealInfo();

  let location = useLocation();
  const [ page, setPage ] = useState('main');

  const [ Dummy, reloadDummy ] = useReloadDummy( randomNumber => changeStates({ dummy: randomNumber }));

  const refreshDeals = async () => await deals.load({ reload: reloadDummy });

  useEffect( () => { refreshDeals() }, [ currency ]);

  useEffect( () => { 
    
    const locationFromURL = location.pathname?.replace("/","")
    let updatedLocation = locationFromURL;

    if ( locationFromURL === "" ) { updatedLocation = "deals";  }
    page !== updatedLocation && setPage( updatedLocation );
    console.log( `changed location:`, updatedLocation ); 
  
  }, [ location ]);

  return (

    <Container 

      className = "main main"
      testLoadDeals = { () => deals.load({ reload: reloadDummy }) }
      popups = {(

        <Fragment>

          { popupSettings.initialize }
          { popupDealInfo.initialize }

        </Fragment>

      )}

    >

      { token_tinkoff_extension && 
      
        <WebSockets

          actions = {{
            refreshDeals
          }}
        
        />
      
      }

      <Dummy />

      <div className = {`scalculator scalculator--page-${ page !== "" ? page : 'main' }`}>

        <History />
        <Orders reloadDummy = { reloadDummy } />

      </div>

    </Container>
    
  );

}

export default Scalculator;